import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InicioComponent } from './components/inicio/inicio.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { ContactoComponent } from './components/contacto/contacto.component';
import { ErrorComponent } from './components/error/error.component';
import { TermCondiComponent } from './components/term-condi/term-condi.component';
import { PoliticaPrivacidadUsoComponent } from './components/politica-privacidad-uso/politica-privacidad-uso.component';


const routes: Routes = [
  {path: '', component:InicioComponent},
  {path: 'nosotros', component:NosotrosComponent},
  {path: 'servicios', component:ServiciosComponent},
  {path: 'contacto', component:ContactoComponent},
  {path: 'terminos-y-condiciones', component:TermCondiComponent},
  {path: 'politica-de-privacidad-y-uso', component:PoliticaPrivacidadUsoComponent},
  {path: 'cotiza', loadChildren: () => import('./cotiza/cotiza.module').then(m => m.CotizaModule) },
  {path: '**', component:ErrorComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
